import React from "react";
import { Grid, Typography } from "@material-ui/core";
import emptySearchImg from "../../../../../assets/img/empty-card.png";
import { translate as t } from "../../../../../infrastructure/translate/localization";
import useStyles from "./styles";

export default function EmptyContentFilter(): JSX.Element {
  const { title, subTitle, imgStyles } = useStyles();
  return (
    <Grid container direction="column" alignItems="center">
      <img src={emptySearchImg} alt="empty-search-img" className={imgStyles} />
      <Typography className={title}>
        {t("common-messages.wow-no-results")}
      </Typography>
      <Typography variant="body2" className={subTitle} align="center">
        {t("recurrent-payments-section.empty-recurrent-payments-message")}
      </Typography>
    </Grid>
  );
}
